module.exports = __webpack_public_path__ + "static/media/16_pol_0_92.22.e9991054.png";